import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import BasicModal from '../../../components/modals/BasicModal';
import { useEffect } from 'react';
import { Mixpanel } from '../../../services/Mixpanel';

export const InputValidationErrorModal = ({ showModal, setShowModal, error }) => {
  useEffect(() => {
    Mixpanel.track('Generate error served', { ...error });
  }, [error]);
  return (
    <BasicModal
      showModal={showModal}
      setShowModal={setShowModal}
      title={error.title}
      iconBackground='bg-amber-100'
      icon={<ExclamationTriangleIcon className='h-6 text-amber-500' />}>
      <div className='text-center '>
        <p className='text-gray-500'>{error.message}</p>
        <div className='flex'>
          <button
            className={`mt-2 inline-flex w-full justify-center items-center font-semibold whitespace-nowrap gap-1 rounded-md bg-none px-4 py-2 ring-1 ring-gray-200 hover:bg-gray-100 `}
            onClick={() => setShowModal(false)}>
            OK
          </button>
        </div>
      </div>
    </BasicModal>
  );
};
